'use client';

import { COUPON_SETTINGS_SHEET } from '@svs/nova-poolbetting/schema/input';
import { CouponToolbox, CouponToolboxButton, CouponToolboxContent } from '@svs/nova-poolbetting/ui/CouponToolbox';
import Settings from '@svs/ui/react/icons/Settings';
import { type ReactNode, Suspense } from 'react';

import { OpenSheetLink } from '@/components/index.browser';
import { usePathname } from '@/lib/index.browser';

/**
 * Coupon toolbox for the result page.
 *
 * @returns Coupon toolbox for the result page
 */
export default function ResultCouponToolbox(): ReactNode {
  const pathname = usePathname();
  return (
    <CouponToolbox>
      <CouponToolboxContent className="p-2 lg:p-4">
        <Suspense>
          <CouponToolboxButton asChild>
            <OpenSheetLink
              sheet={COUPON_SETTINGS_SHEET}
              queriesToKeep="ALL"
              trackingObject={{
                category: 'Nya tipsen',
                action: 'Inställningar',
                optLabel: pathname,
              }}
            >
              <Settings />
              Inställningar
            </OpenSheetLink>
          </CouponToolboxButton>
        </Suspense>
      </CouponToolboxContent>
    </CouponToolbox>
  );
}
